import { Customer } from "../../models/Booking/Customer";
import { Job } from "../../models/Booking/Job";
import { Action } from "../Actions";
import { TabElement } from "./TabElem";
import LS from "../../utils/LocalStorageManager";

const ACTION_ADD_TAB = "ADD_TAB";
const ACTION_CLOSE_TAB = "CLOSE_TAB";
const ACTION_SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
const ACTION_UPDATE_JOB = "UPDATE_JOB";
const ACTION_RESTORE_FROM_LS = "ACTION_RESTORE_FROM_LS";
const ACTION_UPDATE_CUSTOMER_IN_TAB = "ACTION_UPDATE_CUSTOMER_IN_TAB";
const ACTION_UPDATE_LOCATIONS_IN_TAB = "ACTION_UPDATE_LOCATIONS_IN_TAB";

const initialState: TabsState = {
  tabs: {},
  activeTabSid: "",
  tabsQueue: [],
};

export interface TabsState {
  tabs: TabElement;
  activeTabSid: string;
  tabsQueue: string[];
}

export class TabsActions {
  static addTab = (sid: string, tab: any): Action => ({
    type: ACTION_ADD_TAB,
    payload: { sid: sid, tab: tab },
  });
  static closeTab = (sid: string): Action => ({
    type: ACTION_CLOSE_TAB,
    payload: { sid: sid },
  });
  static setActiveTab = (sid: string): Action => ({
    type: ACTION_SET_ACTIVE_TAB,
    payload: { sid: sid },
  });
  static updateJob = (sid: string, job: Job): Action => ({
    type: ACTION_UPDATE_JOB,
    payload: { sid: sid, job: job },
  });
  static updateCustomerInTab = (sid: string, customer: Customer): Action => ({
    type: ACTION_UPDATE_CUSTOMER_IN_TAB,
    payload: { sid: sid, customer: customer },
  });
  static updateLocationsInTab = (sid: string, location: any): Action => ({
    type: ACTION_UPDATE_LOCATIONS_IN_TAB,
    payload: { sid: sid, location: location },
  });
  static restoreTabsFromLs = (): Action => ({
    type: ACTION_RESTORE_FROM_LS,
    payload: {},
  });
}

export function reduce(state: TabsState = initialState, action: Action) {
  switch (action.type) {
    case ACTION_ADD_TAB: {
      const { tabs, tabsQueue } = state;
      if (!tabs[action.payload.sid]) {
        tabs[action.payload.sid] = action.payload.tab;
        tabsQueue.push(action.payload.sid);
      }
      LS.saveTabs({
        tabs: tabs,
        tabsQueue: tabsQueue,
        activeTabSid: action.payload.sid,
      });
      return {
        ...state,
        tabs: tabs,
        tabsQueue: tabsQueue,
        activeTabSid: action.payload.sid,
      };
    }
    case ACTION_CLOSE_TAB: {
      let activeTabSid = "";
      const { tabs, tabsQueue } = state;
      const taskSidOfDeletionTab: string =
        tabs[action.payload.sid]?.taskSid || "";

      if (tabs[action.payload.sid]) {
        delete tabs[action.payload.sid];
        const index = tabsQueue.indexOf(action.payload.sid);
        tabsQueue.splice(index, 1);
        activeTabSid = tabsQueue[index]
          ? tabsQueue[index]
          : tabsQueue[index - 1]
            ? tabsQueue[index - 1]
            : tabsQueue[index + 1]
              ? tabsQueue[index + 1]
              : "";
      }
      LS.removeTaskBySid(taskSidOfDeletionTab);
      LS.saveTabs({
        tabs: tabs,
        tabsQueue: tabsQueue,
        activeTabSid: action.payload.sid,
      });
      return {
        ...state,
        tabs: tabs,
        tabsQueue: tabsQueue,
        activeTabSid: activeTabSid,
      };
    }
    case ACTION_SET_ACTIVE_TAB: {
      LS.updateActiveTab(action.payload.sid);

      return {
        ...state,
        activeTabSid: action.payload.sid,
      };
    }
    case ACTION_UPDATE_JOB: {
      const { tabs } = state;
      const tab = tabs[action.payload.sid];

      if (tab) {
        tab.data = tab.data || {};
        tab.data.job = action.payload.job;
        LS.updateJob(tabs);
      } else {
        console.log(
          "TabsState.ts::ACTION_UPDATE_JOB : Cant find tab by activeTabSid"
        );
      }

      return {
        ...state,
        tabs: tabs,
      };
    }
    case ACTION_UPDATE_CUSTOMER_IN_TAB: {
      const { tabs } = state;
      const tab = tabs[action.payload.sid];

      if (tab) {
        tab.data = tab.data || {};
        tab.data.customer = action.payload.customer;
        LS.updateCustomerInTab(tabs);
      }

      return {
        ...state,
        tabs: tabs,
      };
    }
    case ACTION_UPDATE_LOCATIONS_IN_TAB: {
      const { tabs } = state;
      const tab = tabs[action.payload.sid];

      if (tab) {
        tab.data = tab.data || {};
        tab.data.customerLocation = action.payload.location;
        LS.updateCustomerInTab(tabs);
      }

      return {
        ...state,
        tabs: tabs,
      };
    }
    case ACTION_RESTORE_FROM_LS: {
      const tabsData = LS.getTabsData();

      return {
        ...state,
        ...(tabsData ? tabsData : {}),
      };
    }
    default:
      return state;
  }
}
